(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tb-ui/carousel/assets/javascripts/react/carousel.js') >= 0) return;  svs.modules.push('/components/tb-ui/carousel/assets/javascripts/react/carousel.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const _React = React,
  Children = _React.Children,
  isValidElement = _React.isValidElement,
  useEffect = _React.useEffect,
  useMemo = _React.useMemo,
  useRef = _React.useRef,
  useState = _React.useState;
const CarouselNavigation = svs.components.tbUi.carousel.CarouselNavigation;
const useDrag = svs.components.tbUi.carousel.hooks.useDrag;
const calculateScrollbarWidth = svs.components.tbUi.carousel.utils.calculateScrollbarWidth;
const DRAG_THRESHOLD = 50;
const Carousel = _ref => {
  let branding = _ref.branding,
    children = _ref.children,
    className = _ref.className,
    options = _ref.options;
  const _svs$components$tbUti = svs.components.tbUtils.useMediaQuery,
    useMediaQuery = _svs$components$tbUti.useMediaQuery,
    breakpoints = _svs$components$tbUti.breakpoints,
    BREAKPOINT_AM = _svs$components$tbUti.BREAKPOINT_AM;
  const defaultOptions = {
    isMobile: false,
    selectedIndex: 0,
    theme: 'brand'
  };
  const shouldReduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)") === true || window.matchMedia("(prefers-reduced-motion: reduce)").matches === true;
  const _defaultOptions$optio = _objectSpread(_objectSpread({}, defaultOptions), options),
    isMobile = _defaultOptions$optio.isMobile,
    selectedIndex = _defaultOptions$optio.selectedIndex,
    theme = _defaultOptions$optio.theme;
  const isMobileQuery = useMediaQuery(breakpoints.down(BREAKPOINT_AM));
  const mobileView = isMobile || isMobileQuery;

  const _useState = useState(() => selectedIndex),
    _useState2 = _slicedToArray(_useState, 2),
    index = _useState2[0],
    setIndex = _useState2[1];
  const ref = useRef(null);
  const navRef = useRef(null);
  const cntRef = useRef(null);
  const _useDrag = useDrag(ref),
    enable = _useDrag.enable,
    release = _useDrag.release,
    registerCallbacks = _useDrag.registerCallbacks;
  const mappedChildren = useMemo(() => Children.map(Array.isArray(children) ? children : [children], (child, childIndex) => {
    if (isValidElement(child)) {
      const title = child.props.title;
      const clone = React.cloneElement(child, {
        isSelected: index === childIndex
      });
      return React.createElement("div", {
        "aria-hidden": childIndex !== index,
        "aria-label": title,
        "aria-roledescription": "karusellsida ".concat(index + 1),
        className: ['ui-carousel-item', childIndex === selectedIndex ? 'ui-carousel-item-selected' : ''].filter(Boolean).join(' '),
        role: "group"
      }, React.createElement("div", {
        className: "ui-carousel-item-inner"
      }, clone));
    }
    return null;
  }), [children, index, selectedIndex]);
  const onMove = _ref2 => {
    let x = _ref2.x;
    if (Math.abs(x) > DRAG_THRESHOLD) {
      release();
      setIndex(i => {
        const newIndex = x > 0 ? Math.max(0, i - 1) : Math.min(children.length - 1, i + 1);
        return newIndex;
      });
    }
  };
  registerCallbacks({
    onMove
  });
  enable();

  useEffect(() => {
    const container = ref === null || ref === void 0 ? void 0 : ref.current;
    const keyNavigtion = e => {
      switch (e.code) {
        case 'ArrowLeft':
          setIndex(currentIndex => Math.max(0, currentIndex - 1));
          break;
        case 'ArrowRight':
          setIndex(currentIndex => Math.min(children.length - 1, currentIndex + 1));
          break;
        default:
      }
    };
    container === null || container === void 0 || container.addEventListener('keyup', keyNavigtion);
    return () => {
      container === null || container === void 0 || container.removeEventListener('keyup', keyNavigtion);
    };
  }, [children]);
  useEffect(() => {
    const container = cntRef.current;
    if (ref.current && container) {
      ref.current.style.setProperty('--scrollbar-width', "".concat(calculateScrollbarWidth(), "px"));
      const options = {
        root: ref.current,
        rootMargin: '0px',
        threshold: 1.0
      };
      const intersectionCallback = entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            navRef === null || navRef === void 0 || navRef.current.classList.remove('ui-carousel-nav-sticky');
          } else {
            navRef === null || navRef === void 0 || navRef.current.classList.add('ui-carousel-nav-sticky');
          }
        });
      };
      const observer = new IntersectionObserver(intersectionCallback, options);
      observer.observe(container);
      return () => observer.unobserve(container);
    }
  }, []);
  return (children === null || children === void 0 ? void 0 : children.length) > 0 && React.createElement("div", {
    className: ['ui-carousel', branding ? "ui-carousel-".concat(branding) : '', shouldReduceMotion ? 'ui-carousel-reduced-motion' : '', theme ? "ui-carousel-".concat(theme) : '', mobileView ? 'ui-carousel-mobile' : '', className].filter(Boolean).join(' '),
    "data-testid": "ui-carousel",
    ref: ref
  }, React.createElement("div", {
    className: "ui-carousel-scroll-area"
  }, React.createElement("div", {
    "aria-label": "",
    "aria-roledescription": "karusell",
    className: "ui-carousel-container",
    ref: cntRef
  }, children.length > 1 && React.createElement(CarouselNavigation, {
    numberOfPages: children.length,
    onChange: i => setIndex(i),
    ref: navRef,
    selectedIndex: index
  }), React.createElement("div", {
    "aria-live": "polite",
    className: "ui-carousel-items",
    "data-testid": "ui-carousel-items",
    style: {
      transform: "translateX(".concat(index * 100 * -1, "%)")
    }
  }, mappedChildren), children.length > 1 && React.createElement("div", {
    "aria-atomic": "true",
    "aria-live": "polite",
    className: "visuallyhidden",
    "data-testid": "ui-carousel-live"
  }, "Sida ".concat(index + 1, " av ").concat(children.length)))));
};
Carousel.defaultProps = {
  children: []
};
setGlobal('svs.components.tbUi.carousel.Carousel', Carousel);

 })(window);